import { useSelector } from 'react-redux';

import { selectHasPreviousPage } from '#src/store/location/selectors';

// `showBack` is true only once there's an in-app previous page to go back
// to; `onBack` navigates there via the browser's own history.
export function useBackNavigation() {
  const showBack = useSelector(selectHasPreviousPage);

  return {
    showBack,
    onBack: () => window.history.back(),
  };
}
